import { TicTacToeState, TicTacToeWinner } from '../../../types/game.types'

export const createInitialState = (): TicTacToeState => ({
  board: Array(3).fill(null).map(() => Array(3).fill(null)),
  currentPlayer: 'X',
  winner: null,
  isDraw: false,
  moves: 0,
  scores: { X: 0, O: 0 },
  gameStarted: false,
  gameEnded: false
})

export const checkWinner = (board: ('X' | 'O' | null)[][]): TicTacToeWinner => {
  // Check rows
  for (let i = 0; i < 3; i++) {
    if (board[i][0] && board[i][0] === board[i][1] && board[i][0] === board[i][2]) {
      return board[i][0]
    }
  }
  
  // Check columns
  for (let i = 0; i < 3; i++) {
    if (board[0][i] && board[0][i] === board[1][i] && board[0][i] === board[2][i]) {
      return board[0][i]
    }
  }
  
  // Check diagonals
  if (board[0][0] && board[0][0] === board[1][1] && board[0][0] === board[2][2]) {
    return board[0][0]
  }
  
  if (board[0][2] && board[0][2] === board[1][1] && board[0][2] === board[2][0]) {
    return board[0][2]
  }
  
  return null
}

export const checkDraw = (board: ('X' | 'O' | null)[][]): boolean => {
  return board.flat().every(cell => cell !== null)
}

export const makeMove = (
  state: TicTacToeState,
  row: number,
  col: number
): TicTacToeState => {
  if (state.board[row][col] || state.winner || state.isDraw) {
    return state
  }
  
  const newBoard = state.board.map(r => [...r])
  newBoard[row][col] = state.currentPlayer
  
  const winner = checkWinner(newBoard)
  const isDraw = !winner && checkDraw(newBoard)
  
  const newScores = { ...state.scores }
  if (winner === 'X') newScores.X += 1
  if (winner === 'O') newScores.O += 1
  
  return {
    ...state,
    board: newBoard,
    currentPlayer: state.currentPlayer === 'X' ? 'O' : 'X',
    winner,
    isDraw,
    moves: state.moves + 1,
    scores: newScores,
    gameStarted: true,
    gameEnded: !!winner || isDraw
  }
}

export const resetBoard = (state: TicTacToeState): TicTacToeState => {
  return {
    ...createInitialState(),
    scores: state.scores
  }
}

export const resetGame = (): TicTacToeState => {
  return createInitialState()
}

export const getWinningLine = (board: ('X' | 'O' | null)[][]): number[][] => {
  // Check rows
  for (let i = 0; i < 3; i++) {
    if (board[i][0] && board[i][0] === board[i][1] && board[i][0] === board[i][2]) {
      return [[i, 0], [i, 1], [i, 2]]
    }
  }
  
  // Check columns
  for (let i = 0; i < 3; i++) {
    if (board[0][i] && board[0][i] === board[1][i] && board[0][i] === board[2][i]) {
      return [[0, i], [1, i], [2, i]]
    }
  }
  
  // Check diagonals
  if (board[0][0] && board[0][0] === board[1][1] && board[0][0] === board[2][2]) {
    return [[0, 0], [1, 1], [2, 2]]
  }
  
  if (board[0][2] && board[0][2] === board[1][1] && board[0][2] === board[2][0]) {
    return [[0, 2], [1, 1], [2, 0]]
  }
  
  return []
}